export default "__VITE_ASSET__5a2e0627__"